import { Component, Event, EventEmitter, Host, Prop, State, h } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { If } from '@utils/If';

@Component({
  tag: 'selection-dropdown',
  styleUrl: 'selection-dropdown.scss',
  shadow: true
})
export class SelectionDropdown {
  @Prop() autoFocus: boolean = false;
  @Prop() name: string;
  @Prop() disabled: boolean = false;
  @Prop() label: string;
  @Prop() error?: string = '';
  @Prop() value: string;
  @Prop() type: string = 'text';
  @Prop() inputMode: string = 'text';
  @Prop() maxLength?: number;
  @Prop() fieldInfo?: string;
  @Prop() rightIcon?: string;
  @Prop() readOnly: boolean = false;
  @Prop() loading: boolean = false;
  @Prop() options = [
    {
      name: 'Mr',
      value: 'Mr'
    },
    {
      name: 'Mrs',
      value: 'Mrs'
    },
    {
      name: 'Ms',
      value: 'Ms'
    }
  ];

  @Event() valueChanged: EventEmitter<string>;
  @Event() focused: EventEmitter<void>;
  @Event() blurred: EventEmitter<void>;
  @Event() clickRightIcon: EventEmitter<void>;

  @State() isFocused: boolean = false;
  inputEl?: HTMLInputElement;
  private handleInput = (e: Event) => {
    const target = e.target as HTMLInputElement;
    this.valueChanged.emit(target.value);
  };

  private handleFocus = () => {
    this.focused.emit();
    this.isFocused = true;
  };

  private handleBlur = () => {
    this.blurred.emit();
    this.isFocused = false;
  };

  componentDidLoad() {
    if (this.autoFocus) setTimeout(() => this.inputEl?.focus(), 300);
  }

  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <div class="w-full flex flex-col">
          <div
            class={`border-2 border-solid rounded-[14px] ${this.isFocused ? (!!this.error ? 'border-sb-danger-300 ' : 'border-sb-primary-100') : 'border-transparent'} relative `}
          >
            <select
              // ref={el => (this.inputEl = el as HTMLInputElement)}
              id={this.name}
              name={this.name}
              autocomplete="off"
              inputMode={this.inputMode}
              disabled={this.disabled}
              onInput={this.handleInput}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              class={`w-full text-black text-sm/6.5 min-w-[80px] relative border input border-solid rounded-xl px-3 py-2.5 ${
                this.error ? 'border-sb-danger' : 'border-gray-300 focus:border-sb-primary'
              } focus:outline-none text-sm placeholder-transparent`}
            >
              {this.options.map((item: any, idx: number) => {
                return (
                  <option key={idx} value={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <img class="absolute top-4 right-3" src={assetPath + 'icons/downArrowGray.png'} />

            <label
              htmlFor={this.name}
              class={`absolute  ${this.isFocused ? (!!this.error ? 'text-sb-danger' : 'text-sb-primary') : 'text-gray-500 text-sm'} 
                   bg-white px-1 left-4 cursor-text top-[14px] transition-all pointer-events-none`}
            >
              {this.label}
            </label>
          </div>
          <If condition={!!this.error} children={<p class="text-red-500 text-xs mt-1">{this.error}</p>} />
        </div>
      </Host>
    );
  }
}
